import {BaseElement} from "./baseElement.ts";
import type {jsPDF} from "jspdf";

export class BlockContainer extends BaseElement {
	async calculate(jsPdf: jsPDF) {
		const boundingBox = this.box.getBoundingBox();
		let cursorY = boundingBox.y;
		let totalHeight = 0;
		for (const child of this.children) {
			child.box.position.x = boundingBox.x;
			child.box.position.y = cursorY;
			child.box.size.width = boundingBox.width;
			await child.calculate(jsPdf);
			const childBoundingBox = child.box.getBoundingBox();
			cursorY += childBoundingBox.outerHeight;
			totalHeight += childBoundingBox.outerHeight;
		}
		this.box.size.height = totalHeight;
	}

	override async draw(pdfDocument: jsPDF): Promise<void> {
		for (const child of this.children) {
			await child.draw(pdfDocument);
		}
	}
}
